import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import {ConstantsService} from "../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-search-core',
  templateUrl: './search-core.component.pug',
  styleUrls: ['./search-core.component.scss'],
  standalone: false
})
export class SearchCoreComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Input() options:any[] = [];
  @Input() defaultCol = '';
  @Input() interior = false;
  @Output() searchChange = new EventEmitter();
  onfocus = false;
  @Input() selectedColumns: any = [];
  @Input() PulseTab = false;
  selected: any;
  searchData: any = [];
  labelValue: any = {};
  searchValue = '';
  selectedSearchLabel = '';
  pixels = 45;
  tagDropdown = false;
  tagDropdownIndex = 0;
  dropdownCount = 0;
  addOrder = 0;
  pulseOption = {"label": $localize`Search all for`, "hint": $localize`(Input value)`, "value":"all"}
  @ViewChild('searchwithoptions') searchWithOptions: any;
  @ViewChild('dropdown') searchOption: any;
  @ViewChild('chips') chips: any;

  constructor( private permission: PermissionsService) {
    this.onSearch = _.debounce(this.onSearch, ConstantsService.DEBOUNCE_RATE);
  }

  ngOnInit(): void {
    if( this.options.length != 0) {
      this.defaultCol = this.options[0].value;
    }
  }

  selectColumn(col) {
    this.onfocus = true;
    this.searchWithOptions.nativeElement.focus();
    this.selected = col;
  }

  clearColumn() {
    this.onfocus = false;
    this.selected = null;
  }

  onClickOut(event) {
    if (event.target.value && this.selected !== null) {
      if (!this.selected || Object.keys(this.selected).length === 0 || !this.selected.label) {
        this.selected = {'label': $localize`All`, 'value': 'all', 'searchValue': event.target.value}
      }
      let searchItem = {} as any;
      searchItem = Object.assign({}, this.selected);
      searchItem['searchValue'] = event.target.value;
      this.selected = {};
      searchItem['addOrder'] = this.addOrder += 1;
      if( !this.interior ) {
        this.searchWithOptions.nativeElement.value = '';
        this.searchValue = '';
      }
      this.selectedColumns.push(searchItem);
      this.search();
      this.searchOption.hide()
    } else {
      this.selected = {};
      this.searchChange.emit({});
    }
  }

  setDropdownCount() {
    this.dropdownCount = this.selectedColumns.filter(s => s.dropdown).length
  }
  onSearch(event) {
    this.searchValue = event.target.value;
    if ((!this.selected || Object.keys(this.selected).length === 0) && this.searchValue) {
      this.searchOption.show();
      this.selected = {'label': $localize`All`, 'value': 'all', 'searchValue': this.searchValue}
    }
    if (event.which == 13) {
      this.searchOption.hide();
      this.onfocus = false;
      this.searchWithOptions.nativeElement.blur();
    }
  }
  search() {
    let searchData = [] as any;
    this.selectedColumns
      .forEach(obj => {
          searchData.push({ 'key': obj.value, 'value': obj.searchValue });
      });
    let data = {};
    data['search'] = searchData;
    data['chips'] = this.selectedColumns;
    data['addOrder'] = this.addOrder;
    this.searchChange.emit({
      data
    });
    if(this.interior){
      this.selected={};
      this.selectedColumns=[];
    }
  }

  // Added function to dynamically calculate padding-left spacing onto search button when selected a filter
  math_log(length) {
    return (Math.log(length)*5.125) * (10);
  }
}
